export default __webpack_public_path__ + "static/media/2013.93590e29.png";